import { NextPage } from 'next';
import Head from 'next/head';
import { MetaTags } from '@helpers/meta-tags.helper';
import MainLayout from '@layouts/main-layout/main-layout';
import DedicatedTeamsComponent from '@components/services/dedicated-teams/dedicated-teams';
import { config } from 'config';
import { useRouter } from 'next/router';
import { generateProductJsonLd } from '@helpers/genereteProductsJsonLd';

const DedicatedTeams: NextPage = () => {
  const router = useRouter();
  const url = `${config.HOST}${router.asPath}`;
  return (
    <>
      <Head>
        {MetaTags({
          title: 'Dedicated Software Development Team for Hire 💼 | Agilie',
          description:
            "Need extra developers? Hire a ready team from Agilie. They plug into your workflow and get things done. Let's talk!",
          imageUrl: '/services-images/dedicated-teams/dedicated-teams-meta.png',
        })}
        <link rel="icon" href="/favicon.ico" />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(
              generateProductJsonLd({
                serviceType: 'Dedicated Software Development Team for Hire | Agilie',
                description:
                  "Need extra developers? Hire a ready team from Agilie. They plug into your workflow and get things done. Let's talk!",
                url,
              }),
            ),
          }}
        />
      </Head>
      <MainLayout>
        <DedicatedTeamsComponent />
      </MainLayout>
    </>
  );
};

export default DedicatedTeams;
